import { createContext, ReactNode, useContext } from "react";

const CreditRequestModeContext = createContext({ isPreliminary: false });

interface CreditRequestModeProviderProps {
  children: ReactNode;
  isPreliminary?: boolean;
}

export const CreditRequestModeProvider = ({
  children,
  isPreliminary = false,
}: CreditRequestModeProviderProps) => (
  <CreditRequestModeContext.Provider value={{ isPreliminary }}>
    {children}
  </CreditRequestModeContext.Provider>
);

export const useCreditRequestMode = () => useContext(CreditRequestModeContext);
